import { render, staticRenderFns } from "./celebrations.vue?vue&type=template&id=0ab405d7"
import script from "./celebrations.vue?vue&type=script&lang=js"
export * from "./celebrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports